import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import "bootstrap/dist/js/bootstrap.bundle.min";
import reportWebVitals from "./reportWebVitals";
import * as Sentry from "@sentry/react";

/* global __SENTRY_RELEASE__ */
// Defined by DefinePlugin in the webpack production build. Guarded with
// `typeof` because react-scripts (`npm start`, `npm test`) and the dev/
// storybook configs do not define it; webpack folds the whole expression
// into a literal at build time.
const sentryRelease =
  typeof __SENTRY_RELEASE__ === "string" ? __SENTRY_RELEASE__ : undefined;

Sentry.init({
  dsn: "https://474ca61531ce40048fecb92876e2c7ee@dss.lomavis.com/8",
  release: sentryRelease,
});

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(<App />);

const container = document.getElementById("root");
const root = createRoot(container);

root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
